import {
  PROD_EXCHANGE_ENDPOINT,
  STAGING_EXCHANGE_ENDPOINT
} from "constants/index";

export const formatVolume = (number: number) => {
  const formatter = Intl.NumberFormat("en", {
    notation: "compact",
    maximumSignificantDigits: 4
  });

  if (!number) return null;

  return `$${formatter.format(number)}`;
};

export const calculateSpreadPercent = (bid: string, ask: string) => {
  if (!bid || !ask) return null;
  const difference = Number(ask) - Number(bid);
  const spread = difference / Number(ask);
  return (spread * 100).toFixed(3);
};

export const calculateVolume = (amounts: number[]) =>
  amounts.reduce((acc, amount) => acc + amount, 0);

export const getEnvUrl = (isProd: boolean) =>
  isProd ? PROD_EXCHANGE_ENDPOINT : STAGING_EXCHANGE_ENDPOINT;
